import React, { FunctionComponent, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import Styles from 'components/customModal/CustomModal.module.scss';
import crossImage from 'assets/images/cross.png'

interface CustomModalProps {
  closeDialog?: (event?: React.FormEvent<HTMLDivElement>) => void;
  cssClass?: string;
  wrapperClass?: string;
  heightClass?: string;
  title?: string;
  children: any;
  modalTitleClass?: string;
  modalHeaderClass?: string;
  modalTitle?: string;
  closeModal?: (event?: React.FormEvent<HTMLDivElement>) => void;
  close?: boolean;
  isOpen?: boolean;
  hideHeaderBorder?: boolean;
  hideHeader?: boolean;
}

/** Nested/sequential modals share one body.modal-open lock. */
let openModalCount = 0;

const lockBodyScroll = () => {
  openModalCount += 1;
  if (openModalCount === 1) {
    document.body.classList.add('modal-open');
  }
};

const unlockBodyScroll = () => {
  openModalCount = Math.max(0, openModalCount - 1);
  if (openModalCount === 0) {
    document.body.classList.remove('modal-open');
  }
};

const CustomModal: FunctionComponent<CustomModalProps> = (props: CustomModalProps) => {
  const { children, cssClass, closeDialog, title, wrapperClass, heightClass, modalTitleClass, modalHeaderClass, modalTitle, closeModal, close, isOpen, hideHeaderBorder, hideHeader } = props;
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen !== undefined && !isOpen) {
      setIsClosing(true);
    } else {
      setIsClosing(false);
    }
  }, [isOpen]);

  // Portal to body so z-index isn't trapped under sticky header (or other) stacking contexts.
  // Keep body.modal-open in sync for scroll lock + hiding fixed chat chrome.
  useEffect(() => {
    lockBodyScroll();
    return () => {
      unlockBodyScroll();
    };
  }, []);

  const handleClose = (event?: React.FormEvent<HTMLDivElement>) => {
    if (closeDialog) {
      closeDialog(event);
    }
  };

  const handleCloseModal = (event?: React.FormEvent<HTMLDivElement>) => {
    if (closeModal) {
      closeModal(event);
    }
  };

  const modal = (
    <>
      <section className={`${Styles.modalWrapper} ${wrapperClass} ${isClosing ? Styles.fadeOut : Styles.fadeIn}`}>
        <div className={Styles.modalContent}>
          {!hideHeader && (
            <div className={`${Styles.modalHeader} ${hideHeaderBorder ? Styles.modalHeaderNoBorder : ''} ${modalHeaderClass || ''}`}>
              {close && (
                <button
                  type="button"
                  className={Styles.closeButtonWrapper}
                  onClick={() => handleCloseModal()}
                  aria-label="Close modal"
                >
                  <img src={crossImage} alt="" className={Styles.superHostImg} />
                </button>
              )}
              <div className={`font-weight-600 text-center ${modalTitleClass || Styles.modalFirstTitle}`}>{modalTitle}</div>
              <h4 className={`font-weight-600 text-center ${modalTitleClass || Styles.modalTitle}`}>{title}</h4>
            </div>
          )}
          <div className={`${Styles.modalBody} ${cssClass} ${heightClass} customBodyScroll`}>{children}</div>
        </div>
      </section>
      <div className={`${Styles.modalBgLayer} ${isClosing ? Styles.fadeOut : Styles.fadeIn}`} onClick={handleClose} onKeyPress={handleClose} role="button" tabIndex={0} />
    </>
  );

  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(modal, document.body);
};

export default CustomModal;
